<!--
 * @Author: wsx
 * @Date: 2022-02-23 14:35:24
 * @LastEditTime: 2022-02-28 17:56:47
 * @Description:页面左右两侧的面板
 * @FilePath: \hz-digital-twin\src\components\global\HFrame.vue
-->
<template>
  <div class="HFrame" :class="[type]" :style="{ width: width }">
    <div class="h-frame-content" :class="bodyClass">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, PropType, toRefs } from "vue";
export default defineComponent({
  name: "HFrame",
  components: {},
  props: {
    type: {
      type: String,
      default: "left",
    },
    width: {
      type: String,
      default: "460px",
    },
    bodyClass: {
      type: String,
    },
  },
  setup(props) {
    const state = reactive({});
    const refData = toRefs(state);
    return { ...refData };
  },
});
</script>
<style  lang='scss' scoped >
.HFrame {
  height: 100%;
  pointer-events: auto;
  position: absolute;
  padding: 15px 15px 45px 20px;
  box-sizing: border-box;
  top: 0;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/images/index/cardBf.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: 1;
  }
  &.left {
    left: 0;
  }
  &.right {
    padding: 15px 20px 45px 15px;
    right: 0;
    &::after {
      transform: rotateY(180deg);
    }
  }
  .h-frame-content {
    position: relative;
    z-index: 2;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
}
</style>
